import { ReqCfg, Options, ReqStr } from './types/api'
import { compile, parse } from 'path-to-regexp'
import { isObject, isString, isFunction } from './utils'
import * as methods from './methods'

// 获取请求方法名
export const getMethodName = (reqStr: ReqStr) => {
    const arr = reqStr.match(/\[(.+?)\]/)
    return arr ? arr[1] : 'get'
}

//  获取请求方法
export const getMethod = (reqStr: ReqStr, options: Options) => {
    const type = getMethodName(reqStr)
    const methodMap: any = {
        ...methods,
        ...options.requestMethods
    }
    return methodMap[type] || methodMap['get']
}

// 替换请求方法字符
export const replaceMethodStr = (reqStr: ReqStr) => {
    return reqStr.replace(/\[.*?\]/g, '')
}

// 填充字符参数到 url
const getPath = (reqStr: ReqStr, data: any) => {
    const path = replaceMethodStr(reqStr)
    const reslutUlr = path.replace(/^.*\/\/[^\/]+/, '').replace(/\<(.+?)\>/g, '')
    const toPath = compile(reslutUlr, {
        encode: encodeURIComponent,
    })
    return toPath(data)
}

// 删除url上面对应的参数 防止发送给后端
const removeRequestData = (reqStr: ReqStr, data: any, requestConfig: ReqCfg = {}) => {
    if (requestConfig.removeParams) {
        const url = reqStr.replace(/^.*\/\/[^\/]+/, '').replace(/\<(.+?)\>/g, '')
        try {
            const tokens = parse(url)
            tokens.forEach((token: any) => {
                if (isObject(token) && data[token.name]) {
                    delete data[token.name]
                }
            })
        }
        catch (e) {
            const errJson = [{
                err: 'err',
                info: e
            }, {
                err: 'reqStr',
                info: reqStr
            }, {
                err: 'data',
                info: JSON.stringify(data)
            }, {
                err: 'requestConfig',
                info: JSON.stringify(requestConfig)
            }]
            console.table(errJson)
        }
    }
}

// 获取域名
const getDomain = (reqStr: ReqStr, requestConfig: ReqCfg = {}, options: Options) => {
    const url = replaceMethodStr(reqStr)

    const domain: ReqCfg['domain'] = requestConfig.domain || options.domain

    if (domain) {
        if (isString(domain as string)) return domain
        if (isFunction(domain)) return (domain as any)(url) || url
        if (isObject(domain)) {
            const config: any = {
                ...domain as object
            }
            const reg = /\<(.+?)\>/g
            const result = reg.exec(url)
            if (result) return config[result[1]] || ''
            return ''
        }
    }
    return ''
}

// 替换参数字符
export const replaceParams = (reqStr: ReqStr, data: any, requestConfig: ReqCfg = {}, options: Options) => {
    const domain = getDomain(reqStr, requestConfig, options)
    const path = getPath(reqStr, data)
    removeRequestData(reqStr, data, requestConfig)
    return domain + path
}